import { gsap } from 'gsap';
import { Container, Sprite } from '../../odie';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { getRandomFloat } from 'src/replicant/utils/random';
import { MovieClip } from '@play-co/timestep-core/ui';
import { getMatch2AssetPath } from '../util/assets';

type HitAnimationOptions = {
  scale: number;
};

export class SpiderFallAnimation extends Container implements IAnimation {
  constructor(private options: HitAnimationOptions) {
    super();
  }

  public async start(): Promise<void> {
    const spider = this.createSpider(this.options.scale);
    await this.animateSpider(spider);
  }

  public stop() {}

  private async animateSpider(spider: MovieClip) {
    // spawn spider
    this.view.addSubview(spider);

    const duration = 0.85;
    const duration_half = duration * 0.5;
    const maxDisplacement = 250;
    const targetX = getRandomFloat(
      -maxDisplacement,
      maxDisplacement,
      Math.random,
    );
    const targetUpwardsY = -200;
    const targetDownwardsY = 300;
    const targetScale = this.options.scale * 3.5;

    // animate
    await gsap
      .timeline()
      // displaces sideways
      .to(spider.style, {
        duration,
        x: targetX,
        ease: 'quad.inOut',
      })
      // launches upwards
      .to(
        spider.style,
        {
          duration: duration_half,
          y: targetUpwardsY,
          ease: 'quad.out',
        },
        0,
      )
      // falls downwards
      .to(
        spider.style,
        {
          duration: duration_half,
          y: targetDownwardsY,
          ease: 'quad.inOut',
        },
        duration_half,
      )
      // spins through the air
      .to(
        spider.style,
        {
          duration,
          r: Math.PI * 3,
          ease: 'none',
        },
        0,
      )
      // scales up to simulate coming towards the screen
      .to(
        spider.style,
        {
          duration,
          scale: targetScale,
          ease: 'quad.in',
        },
        0,
      )
      // fades out towards the end
      .to(
        spider.style,
        {
          duration: duration_half,
          opacity: 0,
          ease: 'quad.easeIn',
        },
        duration_half,
      );

    // despawn spider
    this.view.removeSubview(spider);
  }

  private createSpider(scale: number) {
    const spider = new MovieClip({
      superview: this.view,
      url: getMatch2AssetPath('blocks/spider'),
      scale,
    });
    spider.play('ladybug_idle', null, true);
    return spider;
  }
}
